import React, { useEffect, useState } from "react";
import { Row, Form, Tab, Tabs, Col, Container, Collapse } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import isEmpty from "../../../../utils/is-Empty";
import "./index.css";
import { getApi } from "../../../../actions/structure.action";
import CustomTable from "../../common/CustomTable";
import { tableStructures } from "../../../../helpers/table-structures";
import CustomButton from "../../../common/CustomButton";
import { CloseIcon, ViewIcon } from "../../../../assets/svg/svg-icons";
import CustomModalWrap from "../../../common/CustomModalWrap";
import DashbordOrder from "../../common/DashbordOrder/indes";
import moment from "moment-timezone";

const AcceptedOrders = ({ orderStatus, title }) => {
  const dispatch = useDispatch();
  const [showOrderModal, setOrderModal] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState("");
  const [acceptedOrders, setAcceptedOrders] = useState([]);
  const [isOpen, setIsOpen] = useState(true); // Collapsed/expanded state

  const { auth, orders } = useSelector((state) => {
    return state;
  });

  const orderViewToggle = () => setOrderModal(!showOrderModal);
  const OrderDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Order"}</h4>
            <p
              onClick={() => {
                orderViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button  hidden"}
        buttonContant={"view"}
        isModalOpen={showOrderModal}
        showModal={orderViewToggle}
        closeModal={orderViewToggle}
      >
        <DashbordOrder
          id={currentOrderId}
          closeModal={orderViewToggle}
          isModalOpen={showOrderModal}
        />
      </CustomModalWrap>
    );
  };

  useEffect(() => {
    // Fetch orders logic can be added here
    getApi("getOrders", dispatch);
  }, []);

  useEffect(() => {
    if (!isEmpty(orders?.data) && orders?.data.length > 0) {
      const filteredOrders = orders?.data.filter((item) => item.status === `${orderStatus}`);
      setAcceptedOrders(filteredOrders);
    }
  }, [orders, orderStatus]);

  return !isEmpty(acceptedOrders) && acceptedOrders.length > 0 ? (
    <Container className="px-2 no-records pb-0">
      {OrderDetailsModal()}
      <Row className="section-row mb-2">
        {/* Clickable header */}
        <Row
          className="mx-0 mb-2"
          style={{
            cursor: "pointer",
            borderBottom: "1px solid #ddd",
            padding: "0.5rem 0",
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <Col xs="auto" className="flex-grow-1">
            <h4 className="m-0">{title}</h4>
          </Col>
          <Col xs="auto">
            <i
              className={`bi ${isOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
              style={{ fontSize: "1.2rem" }}
            ></i>
          </Col>
        </Row>

        {/* Collapsible content */}
        <Collapse in={isOpen}>
          <div>
            <Row className="mb-2">
              <CustomTable
                enableRowActions
                data={acceptedOrders}
                enableTopToolbar={false}
                enableBottomToolbar={true}
                enablePagination={true}
                enableFilters={false}
                emptyTableMsg={`No data found`}
                positionActionsColumn={"last"}
                muiTableBodyRowProps={({ row }) => {
                  const {
                    status,
                    accepted_at,
                    shipped_at,
                    outfordelivery_at,
                    delivered_at,
                    lp_accepted_at,
                  } = row.original;

                  const todayDate = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");
                  const acceptedDate = accepted_at
                    ? moment(accepted_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                    : null;
                  const shippedDate = shipped_at
                    ? moment(shipped_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                    : null;
                  const outForDeliveryDate = outfordelivery_at
                    ? moment(outfordelivery_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                    : null;
                  const deliveredDate = delivered_at
                    ? moment(delivered_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                    : null;
                  const lpAcceptedDate = lp_accepted_at
                    ? moment(lp_accepted_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                    : null;

                  let highlight = false;
                  if (status === "accepted" && acceptedDate === todayDate) {
                    highlight = true;
                  } else if (status === "shipped" && shippedDate === todayDate) {
                    highlight = true;
                  } else if (status === "outfordelivery" && outForDeliveryDate === todayDate) {
                    highlight = true;
                  } else if (status === "delivered" && deliveredDate === todayDate) {
                    highlight = true;
                  } else if (status === "lpaccepted" && lpAcceptedDate === todayDate) {
                    highlight = true;
                  }

                  return {
                    sx: {
                      backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                      "& td": {
                        backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                      },
                      "&:hover td": {
                        backgroundColor: highlight ? "#d4fcd4 !important" : "rgba(0, 0, 0, 0.04)", // MUI default hover
                      },
                    },
                  };
                }}
                columns={(() => {
                  if (orderStatus === "accepted") {
                    return tableStructures.new_orders_seller_accepted;
                  } else if (orderStatus === "shipped") {
                    return tableStructures.new_orders_seller_shipped;
                  } else if (orderStatus === "lpaccepted") {
                    return tableStructures.new_orders_seller_lpaccepted;
                  } else if (orderStatus === "outfordelivery") {
                    return tableStructures.new_orders_seller_outForDelivery;
                  } else if (orderStatus === "delivered") {
                    return tableStructures.new_orders_seller_delivered;
                  } else {
                    return tableStructures.new_orders_seller;
                  }
                })()}
                initialState={{
                  columnPinning: {
                    right: ["mrt-row-actions"],
                  },
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                    <h4>{title}</h4>
                  </Row>
                )}
                renderRowActions={({ row, table }) => (
                  <div className="table-action-box">
                    <CustomButton
                      buttonClasses="action-button"
                      id={row.original.id}
                      onClick={() => {
                        setCurrentOrderId(row.original.id);
                        orderViewToggle();
                      }}
                    >
                      <ViewIcon />
                    </CustomButton>
                  </div>
                )}
              />
            </Row>
          </div>
        </Collapse>
      </Row>
    </Container>
  ) : (
    <Container className="no-records pb-4">
      <h4 className="title">{title}</h4>
      <p>{`No data found`}</p>
    </Container>
  );
};

export default AcceptedOrders;
